import { Component, OnInit, Inject } from '@angular/core';
import { StatesService } from '../../services/states/states.service';
import { NgForm } from '@angular/forms';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { debug } from 'util';

@Component({
  selector: 'app-paremployee-summary',
  templateUrl: './paremployee-summary.component.html',
  styleUrls: ['./paremployee-summary.component.css']
})
export class ParemployeeSummaryComponent implements OnInit {
  DocListErrMsg;
  DocListErr: boolean = false;
  states: any;
  EmployeeRoles = ["Senior Manager", "Manager", "Employee"];
  agentId;
  data: any = {
    employee_id: '',
    first_name: '',
    last_name: '',
    role: '',
    hire_date: '',
  }
  EmpIdFlag: boolean = false;
  parEmployeeDetailsAdded: any;
  submitSuccess;
  message;
  EmployeeIdCheckMessage;
  employeeExist;
  getAllPAREmployeeData: any[] = [];
  Heroes1234: any[] = [];
  constructor(private statesService: StatesService, private ParEmployeeService: ParEmployeeService, public dialogRef: MatDialogRef<ParemployeeSummaryComponent>, @Inject(MAT_DIALOG_DATA) public EmployeeData: any, @Inject(MAT_DIALOG_DATA) public ListOfEmployees: any) { }
  ngOnInit() {
    this.getAllStates();
    this.getEmployeeDetailsToEdit();
  }

  getEmployeeDetailsToEdit() {
    this.data.employee_id = this.EmployeeData.EmployeeData.EmployeeId;
    this.data.first_name = this.EmployeeData.EmployeeData.FirstName;
    this.data.middle_name = this.EmployeeData.EmployeeData.MiddleName;
    this.data.last_name = this.EmployeeData.EmployeeData.LastName;
    this.data.employment_type = this.EmployeeData.EmployeeData.EmploymentType;
    this.data.role = this.EmployeeData.EmployeeData.Role;
    this.data.hire_date = this.EmployeeData.EmployeeData.HireDate;
    this.data.docId = this.EmployeeData.EmployeeData._id;
  }

  getAllStates() {
    this.statesService
      .getStates()
      .subscribe(res => {
        this.states = res;
        this.states = this.states.States;
      }
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  focusOutFunction() {
    if (!this.data.docId) {
      this.validateEmployeeId(this.data.employee_id);
    } else if (this.data.employee_id !== this.EmployeeData.EmployeeData.EmployeeId) {
      this.validateEmployeeId(this.data.employee_id);
    } else {
      this.EmployeeIdCheckMessage = '';
      this.EmpIdFlag = false;
    }
  }

  validateEmployeeId(employeeId) {
    if (this.data.employee_id) {
      this.employeeExist = this.ListOfEmployees.ListOfEmployees.find(x => x.EmployeeId === this.data.employee_id);
      if (this.employeeExist === undefined) {
        this.EmployeeIdCheckMessage = '';
        this.EmpIdFlag = false;
      } else {
        this.EmpIdFlag = true;
        this.EmployeeIdCheckMessage = 'Employee Id Exists';
      }
    } else {
    }
  }

  onFormSubmit(form: NgForm) {
    this.parEmployeeDetailsAdded = form.value;
    this.parEmployeeDetailsAdded._id = this.data.docId;
    if (this.data.docId) {
      this.ParEmployeeService.parEmployeeEdited(this.parEmployeeDetailsAdded).subscribe(res => {
        if (res.Info === 'PAR Employee data updated ') {
          this.submitSuccess = true;
          this.message = 'Employee Data Upadated Successful';
          this.ParEmployeeService.load.next('success');
          this.onNoClick();
        } else {
          this.message = 'Data is not submitted';
        }
      }, err => {
        this.DocListErrMsg = 'PAR Employee Updation' + err;
        this.DocListErr = true;
      });
    } else {
      this.ParEmployeeService.addParEmployee(this.parEmployeeDetailsAdded).subscribe(res => {
        if (res.Info === 'PAR Employee Created') {
          this.submitSuccess = true;
          this.message = 'ParEmployee added successfully';
          this.ParEmployeeService.load.next('success');
          this.onNoClick();
        } else {
          this.message = 'Data is not submitted';
        }
      }, err => {
        this.DocListErrMsg = 'PAR Employee Creation' + err;
        this.DocListErr = true;
      });
    }
  }


}




// WEBPACK FOOTER //
// ./src/app/components/paremployee-summary/paremployee-summary.component.ts